import { ApiResponseType } from "../components/types";
import axiosClient from "./axios.client";

export const createTransaction = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/create-transaction",
        data
    );
    return response.data;
};

export const createTransactionWithNFT = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/create-transaction-with-nft",
        data
    );
    return response.data;
};

export const submitTransaction = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/submit-transaction",
        data
    );
    return response.data;
};

export const getTransactionStatus = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/get-transaction-status",
        data
    );
    return response.data;
};

export const getProgramStatus = async (): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/get-program-state"
    );
    return response.data;
};

export const getProfile = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/get-profile",
        data
    );
    return response.data;
};

export const createUpdateMintingEnabled = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/create-update-minting-enabled",
        data
    );
    return response.data;
};

export const createUpdateLevelRatios = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/create-update-level-ratios",
        data
    );
    return response.data;
};

export const getHistories = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/get-histories",
        data
    );
    return response.data;
};

export const getWithdrawTransaction = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "bot/get-withdraw-transaction",
        data
    );
    return response.data;
};

export const checkSAValid = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>("bot/check-sa-valid", data);
    return response.data;
};

export const createUpdateTokenRatio = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>("bot/create-update-token-ratio", data);
    return response.data;
};

////////////////////////////////////////
// Reward
////////////////////////////////////////
export const getRewardSettings = async (): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "reward/get-reward-settings"
    );
    return response.data;
};

export const updateRewardSettings = async (
    data: any
): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "reward/update-reward-settings",
        data
    );
    return response.data;
};

export const getRewardHistory = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "reward/get-reward-history",
        data
    );
    return response.data;
};

export const runReward = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>(
        "reward/run-reward",
        data
    );
    return response.data;
};

export const commandReward = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>("reward/command-reward", data);
    return response.data;
};

export const createUpdateMinSignupAmount = async (data: any): Promise<ApiResponseType> => {
    const response = await axiosClient.post<ApiResponseType>("bot/create-update-min-signup-amount", data);
    return response.data;
};

export const getRewardCSV = async (params: { rewardVersion?: number }): Promise<Blob> => {
    try {
        const response = await axiosClient.post(
            "reward/get-reward-csv",
            params,
            {
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Error getting reward CSV:", error);
        throw error;
    }
};


